import * as constants from './constants';

export const getSet = (payload) => ({ type: constants.GET_SET, payload });
export const getSetSuccess = (payload) => ({ type: constants.GET_SET_SUCCESS, payload });
export const getSetError = (payload) => ({ type: constants.GET_SET_ERROR, payload });

export const openItem = (payload) => ({ type: constants.OPEN_SET, payload });
export const closeItem = (payload) => ({ type: constants.CLOSE_SET, payload });

export const resetSet = () => ({ type: constants.RESET_SET });

export const deleteSet = (payload) => ({ type: constants.DELETE_SET, payload });
export const deleteSetSuccess = () => ({ type: constants.DELETE_SET_SUCCESS });
export const deleteSetError = (payload) => ({ type: constants.DELETE_SET_ERROR, payload });

export const createSet = (payload) => ({ type: constants.SET_CREATE, payload });
export const createSetSuccess = () => ({ type: constants.SET_CREATE_SUCCESS });
export const createSetError = (payload) => ({ type: constants.SET_CREATE_ERROR, payload });

export const batchAddToSet = (payload) => ({ type: constants.BATCH_ADD_TO_SET, payload });
export const batchAddToSetSuccess = () => ({ type: constants.BATCH_ADD_TO_SET_SUCCESS });
// eslint-disable-next-line max-len
export const batchAddToSetError = (payload) => ({ type: constants.BATCH_ADD_TO_SET_ERROR, payload });

export const editSet = (payload) => ({ type: constants.SET_EDIT, payload });
export const editSetSuccess = () => ({ type: constants.SET_EDIT_SUCCESS });
export const editSetError = (payload) => ({ type: constants.SET_EDIT_ERROR, payload });

export const batchRemoveFromSet = (payload) => ({ type: constants.BATCH_REMOVE_FROM_SET, payload });
export const batchRemoveFromSetSuccess = () => ({ type: constants.BATCH_REMOVE_FROM_SET_SUCCESS });
// eslint-disable-RemoveFromline max-len
export const batchRemoveFromSetError = (payload) => ({ type: constants.BATCH_REMOVE_FROM_SET_ERROR, payload });
